import { BoelsBannerTeaser } from './banners.model';
import { CmsComponent } from './cms.model';
import { BackgroundColorEnum } from './boels-background-color.model';

export enum CardComponentType {
  TEASER = 'card card--teaser',
  CARDS = 'card',
}

export enum CardsPropertyName {
  TEASER = 'teasers',
  CARDS = 'cards',
}

export enum CardShapeEnum {
  SQUARE = 'SQUARE',
  RECTANGLE = 'RECTANGLE',
}

export interface BoelsTeaserComponentData extends BoelsBannerTeaser {
  titleColor?: string;
  backgroundGradient?: boolean;
}

export interface AbstractCardComponent extends CmsComponent {
  title?: string;
  backgroundColor: BackgroundColorEnum;
  shape?: CardShapeEnum;
  removeBottomSpacing?: boolean;
}

export interface Card {
  title: string;
  text: string;
  media: string;
  buttonText: string;
  buttonUrl: string;
}

export interface CardsGroupComponentData extends AbstractCardComponent {
  title: string;
  cards: Card[];
}

export interface TeasersGroupComponentData extends AbstractCardComponent {
  teasers: string;
}
